<template>
  <div>
    <p>Mit unserem Entschädigungs-Manager können Sie Ihre Flugverspätungs-Entschädigung schnell
      und unkompliziert direkt bei der betreffenden Fluglinie einfordern. <a @click="toggleShowInfo">So
        funktioniert's&nbsp;<i class="fa fa-sort-desc" aria-hidden="true"></i></a>
    </p>
    <div v-if="viewData.showInfo">
      <div class="row">
        <div class="small-12 medium-1 columns" style="text-align: center;">
          <i class="fa fa-pencil-square-o fa-2x" aria-hidden="true"></i>
        </div>
        <div class="small-12 medium-11 columns">
          <p>
            <strong>1. Geben Sie Ihre Daten in das Formular ein</strong>. Wollen Sie die <strong>Entschädigung für
            Mitreisende</strong> geltend machen, können Sie diese ebenfalls eintragen (auf Nachfrage müssen Sie der
            Fluglinie eine unterzeichnete Bestätigung dieser Mitreisenden nachreichen).
          </p>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-1 columns" style="text-align: center;">
          <i class="fa fa-check-square-o fa-2x" aria-hidden="true"></i>
        </div>
        <div class="small-12 medium-11 columns">
          <p><strong>2. </strong>Wenn Sie auf "Weiter" klicken, prüft unser Entschädigungs-Manager, <strong>ob und auf
            wie viel Entschädigung Sie Anspruch haben</strong> (250, 400 oder 600 Euro).
          </p>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-1 columns" style="text-align: center;">
          <i class="fa fa-file-text-o fa-2x" aria-hidden="true"></i>
        </div>
        <div class="small-12 medium-11 columns">
          <p><strong>3. </strong>Ergibt unsere Überprüfung, dass Ihnen wahrscheinlich eine Entschädigung zusteht,
            <strong>erstellt unser Entschädigungs-Manager automatisch ein Forderungs-Schreiben</strong>. Dieses
            Schreiben können Sie nochmals überprüfen und Ihre Angaben gegebenenfalls korrigieren.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-1 columns" style="text-align: center;">
          <i class="fa fa-envelope-o fa-2x" aria-hidden="true"></i>
        </div>
        <div class="small-12 medium-11 columns">
          <p><strong>4. </strong>Wenn Sie anschließend auf "Absenden" klicken, wird das Forderungs-Schreiben <strong>per
            E-Mail automatisch und kostenlos an die betroffene Fluglinie</strong> geschickt. Bei deutschsprachigen
            Fluglinien wird das Schreiben auf Deutsch versendet, ansonsten auf Englisch. Sie erhalten eine <strong>Kopie
              der E-Mail an Ihre eigene Mail-Adresse</strong>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "HowTo",
        data: () => ({
            viewData: {
                showInfo: false
            }
        }),
        methods: {
            toggleShowInfo()
            {
                this.viewData.showInfo = !this.viewData.showInfo;
            }
        }
    }
</script>

<style scoped>

</style>
